import { render } from "./loginOtp.vue?vue&type=template&id=4a7bd548"
import script from "./loginOtp.vue?vue&type=script&lang=js"
export * from "./loginOtp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Build Apps\\Natan\\jlm_manager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__